import { classes } from 'html-classes';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';

import Price from '~/components/Price';

import { cartStore } from '~/stores';

import styles from './CartCostItemsVariant1.module.scss';

const CartCostItemsVariant1 = () => {
  const { t } = useTranslation();

  return (
    <>
      <ul className={styles.content}>
        <li className={styles.content__item}>
          <div className={styles.content__item__desc}>
            <p>
              {t('itemsN')}{' '}
              <span className={styles.content__item__desc__count}>
                ({cartStore.selectedItemsTotalCount})
              </span>
            </p>
          </div>
          <Price price={cartStore.totalCartPrice.base} />
        </li>
        {Number(cartStore.totalCartPrice.discount) > 0 && (
          <li className={styles.content__item}>
            <div className={styles.content__item__desc}>
              <p>{t('discount')}</p>
            </div>
            <Price
              price={`-${cartStore.totalCartPrice.discount}`}
              className={styles.discountPrice}
              classNameCurrentPrice={styles.content__item__price}
            />
          </li>
        )}
        {Number(cartStore.totalCartPrice.promocodeDiscount) > 0 && (
          <li className={styles.content__item}>
            <div className={styles.content__item__desc}>
              <p>{t('promocode')}</p>
            </div>
            <Price
              price={`-${cartStore.totalCartPrice.promocodeDiscount}`}
              className={styles.discountPrice}
              classNameCurrentPrice={styles.content__item__price}
            />
          </li>
        )}
      </ul>
      <div className={classes([styles.price, styles.price__current])}>
        <p>{t('subtotal')}</p>
        <Price
          price={cartStore.totalCartPrice.paidWithDiscount}
          classNameCurrentPrice={styles.price_current}
        />
      </div>
    </>
  );
};

export default observer(CartCostItemsVariant1);
